import InstagramLogin from './views/InstagramLogin'

export default {
  name:"instagram-login2",
  edit:InstagramLogin,
  create:InstagramLogin,
  list:InstagramLogin,
}
